import { Typography } from "@mui/material";
import React from "react";

const PlanoTypography = ({ css, children, className }) => {
  return (
    <Typography className={className} sx={css}>
      {children}
    </Typography>
  );
};

export default PlanoTypography;
